import { format } from "date-fns";
import { dateFormatMonth } from "../../../constants/app-constants";
import { getMasterStatus } from "../../Common/ListOfStatus";
import ReactModal from "../../Common/ReactModal";
import React from "react";
class GenericMasterView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: "You dont have permission to do this Action"
    };
    this.editGenericMaster = this.editGenericMaster.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }
  submitModal() {
    this.setState({ reactModalVisible: false });
  }
  editGenericMaster() {
    if (this.props.accessSpecifier.editP) {
      this.props.toggleEditMode(true);
    } else {
      this.setState({ reactModalVisible: true });
    }
  }
  render() {
    const { reactModalVisible, requireCancel, modalMessage } = this.state;
    const {
      _id,
      description,
      createdOn,
      lastModifiedOn
    } = this.props.genericMaster;
    var createdByValue = this.props.genericMaster.createdBy.loginId;
    var lastModifiedByValue = this.props.genericMaster.lastModifiedBy.loginId;
    var masterForValue = this.props.genericMaster.masterFor.description;
    const statusValue = getMasterStatus(this.props.genericMaster.status)[0]
      .name;
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
        <div className="row">
          <div className="col-md-11">
            <h1 className="heading m-b-25"> {`${masterForValue} ${_id}`}</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-6" />
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div className="form-group">
                    <label>
                      Description<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={description}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="form-group">
                    <label>
                      STATUS <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={statusValue}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="form-group">
                    <label>CREATED BY</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={createdByValue}
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title={createdByValue}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div className="form-group">
                    <label>CREATED ON </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={`${format(new Date(createdOn), dateFormatMonth)}`}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="form-group">
                    <label>LAST MODIFIED BY</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={lastModifiedByValue}
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title={lastModifiedByValue}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="form-group">
                    <label>LAST MODIFIED ON </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={`${format(
                        new Date(lastModifiedOn),
                        dateFormatMonth
                      )}`}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-5">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={this.editGenericMaster}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
            {/* Form Section End */}
          </div>
        </div>
      </>
    );
  }
}

export default GenericMasterView;
